<div
  [attr.data-testid]="'tender-card-' + tender().tenderMappingId"
  class="generic-card level-second rounded-lg shadow-sm p-6 flex flex-col h-full space-y-8"
>
  <div class="flex justify-between items-center">
    <h3 class="text-lg font-semibold truncate mb-0">{{ tender().companyName }}</h3>
    <div class="flex justify-end">
      <app-provider-tender-card-chat [tender]="tender()" />
    </div>
  </div>

  <div>
    <span class="text-sm opacity-75">{{ 'provider.tenders.project' | transloco }}</span>
    <div class="font-medium">
      {{ tender().projectName }}
    </div>
  </div>

  <div class="flex justify-between items-start">
    <div class="flex gap-4 items-start">
      <div class="flex flex-col justify-start items-start gap-1">
        <div class="text-sm opacity-75">{{ 'common.hrTool' | transloco }}</div>
        <div class="font-medium">{{ hrToolTranslations() | translateDirectus }}</div>
      </div>
      <app-tender-card-contact-select-form
        [tenderId]="tender().tenderMappingId"
        [inputObject]="contractPerson()"
        (contactPersonSaved)="hasContactPerson.set(true)"
      />
    </div>
    <div class="text-right">
      <span class="text-sm opacity-75">{{ 'provider.tenders.submissionDate' | transloco }}</span>
      <div class="font-medium">
        {{ tender().activePhaseStatusInfo.submissionDate | appDate }}
      </div>
    </div>
  </div>

  <div class="flex-1">
    <div class="flex items-center gap-1 mb-3">
      <span class="text-xs font-semibold uppercase me-1">{{
        'provider.tenders.providerStatus' | transloco
      }}</span>
      <app-directus-tooltip tooltipKey="provider.tenders.providerStatus" tooltipPosition="top" />
    </div>

    <div
      class="grid gap-1 mb-2"
      [style.grid-template-columns]="
        'repeat(' + tender().phaseStatusInfos.length + ', minmax(0, 1fr))'
      "
    >
      @for (phaseStatusInfo of tender().phaseStatusInfos; track $index) {
        <app-tender-phase
          [phaseStatusInfo]="phaseStatusInfo"
          [tenderId]="tender().tenderMappingId"
        />
      }
    </div>
  </div>

  <div class="flex justify-between items-end">
    <div>
      <div class="flex items-center gap-1 mb-2">
        <span class="text-xs font-semibold uppercase me-1">{{
          'provider.tenders.customerStatus' | transloco
        }}</span>
        <app-directus-tooltip tooltipKey="provider.tenders.customerStatus" tooltipPosition="top" />
      </div>
      <div class="px-3 py-2 bg-third-level rounded-lg text-sm">
        {{ customerStatusLabel() }}
      </div>
    </div>

    <div class="flex justify-end">
      @if (actionButton().visible) {
        <span
          [pTooltip]="'common.provider.tenders.contact.missing' | transloco"
          [tooltipDisabled]="hasContactPerson()"
          tooltipPosition="top"
        >
          <p-button
            (onClick)="onAnswerRequest()"
            styleClass="uppercase tracking-wider text-sm!"
            severity="primary"
            [disabled]="!hasContactPerson()"
          >
            <span
              >{{ tender().activePhaseStatusInfo.phase }} {{ actionButton().labelKey | transloco }}
            </span>
          </p-button>
        </span>
      }
    </div>
  </div>
</div>
